import {
  handleActions,
  combineActions,
} from 'redux-actions';
import update from 'immutability-helper';
import _ from 'lodash';

import MetadataActionCreators from '../actions/MetadataActionCreators';

const {
  getMetadataRequest,
  getMetadataSuccess,
  getMetadataFailure,
  createMetadataRequest,
  createMetadataSuccess,
  createMetadataFailure,
  updateMetadataRequest,
  updateMetadataSuccess,
  updateMetadataFailure,
  deleteMetadataRequest,
  deleteMetadataSuccess,
  deleteMetadataFailure,
} = MetadataActionCreators;

const initialState = {
  isLoading: false,
  data: {},
};

export default handleActions({
  [combineActions(
    getMetadataRequest,
    createMetadataRequest,
    updateMetadataRequest,
    deleteMetadataRequest,
  )]: state => update(state, {
    isLoading: { $set: true },
  }),
  [getMetadataSuccess]: (state, {
    payload: {
      metadatas = [],
      metadataTypes = [],
    },
  }) => {
    // typeMap is mirror mapping between id and type string!
    const typeMap = metadataTypes.reduce((all, { id, name = '' }) => ({
      ...all,
      [id]: _.camelCase(name),
      [_.camelCase(name)]: id,
    }), {});
    const metadataMap = metadatas.reduce((all, metadata) => {
      const typeName = _.camelCase(typeMap[metadata.metadataTypeId]);
      return ({
        ...all,
        [typeName]: (all[typeName] || []).concat({ ...metadata, key: metadata.id }),
      });
    }, {});
    return update(state, {
      isLoading: { $set: false },
      data: { $set: metadataMap },
      type: { $set: typeMap },
    });
  },
  [combineActions(
    createMetadataSuccess,
    updateMetadataSuccess,
    deleteMetadataSuccess,
    getMetadataFailure,
    createMetadataFailure,
    updateMetadataFailure,
    deleteMetadataFailure,
  )]: state => update(state, {
    isLoading: { $set: false },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/metadata.js